var DEVICE_TYPE = null; //手機裝置才會給予內容值
var DEVICE_TOKEN = null; //手機裝置才會給予內容值
var DEVICE_ID = null; //手機裝置才會給予內容值
var USER_ID = null; //手機裝置才會給予內容值
//2023-07-10 Johnson 資安2023
var PWD = eval(function(p,a,c,k,e,r){e=String;if(!''.replace(/^/,String)){while(c--)r[c]=k[c]||c;k=[function(e){return r[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('0;',2,1,'null'.split('|'),0,{})) //手機裝置才會給予內容值
var APP_VERSION = -1; //
var IOS_VERSION = null;

function setSsoInfo(data) {
    sessionStorage.setItem('token', data.Token);
    sessionStorage.setItem('cName', data.CName);
    sessionStorage.setItem('perSerilNo', data.PerSerilNo || data.PerserilNo);
}

function removeSsoInfo() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('perSerilNo');
    sessionStorage.removeItem('cName');
    sessionStorage.removeItem('isForce');
}


var errorMsgs = [];

// 判斷相同錯誤是否已經提報伺服端
// 避免無窮迴圈的錯誤不斷發送攻擊
function isAlreadyReport(mewMsg) {
    if (errorMsgs.length > 0) {
        for (let index = 0; index < errorMsgs.length; index++) {
            const msg = errorMsgs[index];
            if (msg == mewMsg) {
                return true;
            }
        }
    }
    return false;
}

//filter the exception that no use
var isNoUseErrors = ['$digest already in progress'];

function isNoUseError(msg) {
    var result = false;
    for (var i = 0; i <= isNoUseErrors.length - 1; i++) {
        if (msg.indexOf(isNoUseErrors[i]) > -1) {
            result = true;
            break;
        }
    }
    return result;
}


function postException(exception, apiUrl) {
    var param = {
        exception: exception,
        route: location.href,
        perSerilNo: sessionStorage.getItem('perSerilNo')
    };

    // 發送到後端記錄錯誤LOG (重複的LOG就不要再直直送了)
    if (isAlreadyReport(param.exception) == false && !isNoUseError(param.exception)) {
        errorMsgs.push(param.exception)

        console.log("call postException");
        //console.log(data);

        // 20181002 停止使用前端 Log 機制，因為無意義的錯誤紀錄會造成誤解，此外也無法透過此機制得到任何除錯幫助
        // $.post(apiUrl.tsApi + 'log/PostFront', param).then(function(data) {
        //     //console.log("call postException ["+apiUrl.tsApi + 'log/PostFront'+"],result:", data);
        // });
    }

}

function queryString(name) {
    // console.log("queryString");
    // console.log("location.href",location.href);
     //2023-07-10 Johnson 資安2023
    var AllVars = eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('3.4.5(\'?\')[1].0(/</2,\'&6\').0(/>/2,\'&7\').0(/"/2,\'&8\').0(/\'/2,\'&#9\').0(/[<>!]|(\\(\\))|((a|b|c)\\d*\\(.*\\))/2,\'\')', 14, 14, 'replace||g|location|href|split|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}))
    var Vars = AllVars.split('&');
    for (let i = 0; i < Vars.length; i++) {
        var Var = Vars[i].split("=");
        if (Var[0] == name) {
            return Var[1];
        }
    }
    return "";
}

function getMenuQueryString() {
    if (location.href.split('menu=').length > 1) {
        return location.href.split('menu=')[1];
    }
    return undefined;
}

function showSystemError() {
    var errorMessage;
    switch (sessionStorage['userLang']) {
        case 'zh-TW':
            errorMessage = '很抱歉！此頁面發生了一些錯誤，系統已自動通知網站管理員，將儘速為您處理，請您稍後再使用本功能。';
            break;
        case 'zh-CN':
            errorMessage = '很抱歉！此页面发生了一些错误，系统已自动通知网站管理员，将尽速为您处理，请您稍后再使用本功能。 ';
            break;
        case 'en-US':
            errorMessage = 'very sorry! Some errors occurred on this page, the system automatically notify your webmaster will process as soon as possible for you, please try again later with this function. ';
            break;
    }

    toastr.error(errorMessage);
}
// function getDefaultLangCode() {
//     var langSerilNo = 1;
//     var userLang = navigator.language || navigator.userLanguage;
//     sessionStorage.setItem('userLang', userLang);
//     userLang = _.replace(userLang, '_', '-');
//     switch (userLang.toLowerCase()) {
//         case 'zh-cn':
//             langSerilNo = 2;
//             break;
//         case 'en-us':
//             langSerilNo = 3;
//             break;
//         case 'zh-tw':
//             langSerilNo = 1;
//             break;
//     }
//     sessionStorage.setItem('langCode', langSerilNo);
//     return langSerilNo;
// }

function getLangCode(userLang) {

    var langSerilNo = 1;
    sessionStorage.setItem('userLang', userLang);
    userLang = _.replace(userLang, '_', '-');
    switch (userLang.toLowerCase()) {
        case 'zh-cn':
            langSerilNo = 2;
            break;
        case 'en-us':
            langSerilNo = 3;
            break;
        case 'zh-tw':
            langSerilNo = 1;
            break;
    }
    sessionStorage.setItem('langCode', langSerilNo);
    return langSerilNo;
}


function getDefaultUserLang(tsApiUrl, ieSystemLang) {
    return jQuery.ajax({
        type: "GET",
        url: tsApiUrl + 'header/acceptSupportedLanguage?ieSystemLang=' + ieSystemLang,
        async: false
    });
}

function intConvertTime(intTimeSpan) {
    var sec_num;
    try {
        sec_num = parseInt(intTimeSpan, 10); // don't forget the second param
    } catch (exp) {
        sec_num = 0;
    }
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }
    return hours + ':' + minutes + ':' + seconds;
}


function appCallback(method, params) {
    var Base64 = {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        encode: function(e) {
            var t = "";
            var n, r, i, s, o, u, a;
            var f = 0;
            e = Base64._utf8_encode(e);
            while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) { u = a = 64 } else if (isNaN(i)) { a = 64 }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a)
            }
            return t
        },
        decode: function(e) {
            var t = "";
            var n, r, i;
            var s, o, u, a;
            var f = 0;
            e = e.replace(/[^A-Za-z0-9+/=]/g, "");
            while (f < e.length) {
                s = this._keyStr.indexOf(e.charAt(f++));
                o = this._keyStr.indexOf(e.charAt(f++));
                u = this._keyStr.indexOf(e.charAt(f++));
                a = this._keyStr.indexOf(e.charAt(f++));
                n = s << 2 | o >> 4;
                r = (o & 15) << 4 | u >> 2;
                i = (u & 3) << 6 | a;
                t = t + String.fromCharCode(n);
                if (u != 64) {
                    t = t + String.fromCharCode(r)
                }
                if (a != 64) { t = t + String.fromCharCode(i) }
            }
            t = Base64._utf8_decode(t);
            return t
        },
        _utf8_encode: function(e) {
            e = e.replace(/rn/g, "n");
            var t = "";
            for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r)
                } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128)
                } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128)
                }
            }
            return t
        },
        _utf8_decode: function(e) {
            var t = "";
            var n = 0;
            var r = c1 = c2 = 0;
            while (n < e.length) {
                r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                    n++
                } else if (r > 191 && r < 224) {
                    c2 = e.charCodeAt(n + 1);
                    t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                    n += 2
                } else {
                    c2 = e.charCodeAt(n + 1);
                    c3 = e.charCodeAt(n + 2);
                    t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                    n += 3
                }
            }
            return t
        }
    };
    var encParams = Base64.encode(JSON.stringify(params));
    if (method.match('CloseWebView')) { method = 'CloseWebView' };
    var tmpFrame = document.createElement("frame");
    document.documentElement.appendChild(tmpFrame);
    tmpFrame.src = ("app://[method]?p=[params]")
        .replace("[method]", method)
        .replace("[params]", encParams);
    setTimeout(function() { document.documentElement.removeChild(tmpFrame) }, 0);
}

function p(jstr) {
    try {
        return JSON.parse(jstr);
    } catch (e) {
        return {};
    };
}


function fixIeNotAbleToInput(selector = '') {

    setTimeout(function() {
        $(`${selector} input`).each(function() {
            // $(this).attr("placeholder", window.location);
            // $(this).css({ "background-color": "blue" });
            $(this).focus(function() {
                $(this).select();
            });
        });

        $(`${selector} textarea`).each(function() {
            // $(this).attr("placeholder", window.location);
            // $(this).css({ "background-color": "blue" });
            $(this).focus(function() {
                $(this).select();
            });
        })
    }, 500);
}

function infoDebug(msg) {
    var param = {
        Command: msg
    };
    window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(param));
}